module.exports = __webpack_public_path__ + "18375d6fb32785bd6d5e0f7f1550516c.png";